import {
    FETCH_VEHICLE_TRIPS_BEGIN,
    FETCH_VEHICLE_TRIPS_SUCCESS,
    FETCH_VEHICLE_TRIPS_FAILURE,
  } from "../actions/VehicleTrips";
  
  const initialState = {
    vehicleTrips: {},
    loading: false,
    error: null,
  };
  
  export default function vehicleTripsReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_VEHICLE_TRIPS_BEGIN:
        return {
          ...state,
          loading: true,
          error: null,
        };
  
      case FETCH_VEHICLE_TRIPS_SUCCESS:
        return {
          ...state,
          loading: false,
          vehicleTrips: action.payload,
        };
  
      case FETCH_VEHICLE_TRIPS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
          vehicleTrips: {},
        };
  
      default:
        return state;
    }
  }
  